import * as ElIcons from '@element-plus/icons-vue';
import VueMatomo from '@shining3d/matomo';
import { get } from 'lodash';
import { createApp } from 'vue';
import { VueCookieNext } from 'vue-cookie-next';
import App from './App.vue';
import router from './router/index.js';
import store from './store/index.js';
// import './assets/common/font.css';
import './assets/font/iconfont';
import './assets/font/iconfont.css';
// root主题色文件
import './assets/common/common.scss';
import './assets/common/root.scss';
import '@shining3d/ui-components-theme/lib/css/elCommon.css';

const userId = VueCookieNext.getCookie( 'user_id' );
const app = createApp( App );
for ( const name in ElIcons ) {
	app.component( name, ElIcons[ name ]);
}

app.use( VueMatomo, {
	// matomo服务器站点地址
	// host: 'https://matomo.dental3dcloud.com',
	// trackerFileName: 'matomo',
	trackerUrl: '/api/matomoCollector?source=openCloud',
	trackerScriptUrl: get( window, 'app.global.matomo.scriptUrl', 'https://t-pubhz.oss-accelerate.aliyuncs.com/sysParams/matomo-s.js' ),
	siteId: get( window, 'app.global.matomo.idsite', 24 ),
	projectID: get( window, 'app.global.matomo.projectId', '12a1d145-2825-5366-a143-fc8fc98880a4' ),
	log: true,
	// 自动注册Vue路由
	router: router,
	// 是否开启常规页面跳转追踪
	// 默认: true
	enableLinkTracking: true,
	// 再向matomo发送追踪信息前需要同意
	// 默认: false
	requireConsent: false,
	// 是否追踪初始化页面
	// 默认: true
	trackInitialView: true,
	// 是否关闭cookies运行matomo
	// 默认: false
	disableCookies: false,
	// 创建matomo服务前是否征得用户cookie授权
	// 默认: false
	requireCookieConsent: false,
	// 是否收集debug环境下的信息
	// 默认: false
	debug: false,
	// userid
	userId: userId || ''
});
app.use( VueCookieNext );
app.use( store );
app.use( router );
app.mount( '#app' );
